import type { FC } from "react";
import { zodResolver } from "@hookform/resolvers/zod";
import { useForm } from "react-hook-form";
import * as z from "zod";
import {
	Form,
	FormControl,
	FormDescription,
	FormField,
	FormItem,
	FormLabel,
	FormMessage,
} from "@/components/ui/form";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { useToast } from "@/hooks/ui/use-toast";
import { useAuth } from "@/hooks/useAuth";

const emailFormSchema = z.object({
	email: z
		.string()
		.email({ message: "有効なメールアドレスを入力してください" }),
	currentPassword: z
		.string()
		.min(1, { message: "現在のパスワードを入力してください" }),
});

type EmailFormValues = z.infer<typeof emailFormSchema>;

export const EmailForm: FC = () => {
	const { user } = useAuth();
	const { toast } = useToast();

	const form = useForm<EmailFormValues>({
		resolver: zodResolver(emailFormSchema),
		defaultValues: {
			email: user?.email || "",
			currentPassword: "",
		},
	});

	const onSubmit = async (data: EmailFormValues) => {
		try {
			// TODO: メールアドレス変更のAPI呼び出し
			toast({
				title: "確認メールを送信しました",
				description: "新しいメールアドレスに確認メールを送信しました",
			});
		} catch (error) {
			toast({
				title: "エラーが発生しました",
				description: "メールアドレスの変更に失敗しました",
				variant: "destructive",
			});
		}
	};

	return (
		<Form {...form}>
			<form onSubmit={form.handleSubmit(onSubmit)} className="space-y-6">
				<FormField
					control={form.control}
					name="email"
					render={({ field }) => (
						<FormItem>
							<FormLabel>新しいメールアドレス</FormLabel>
							<FormControl>
								<Input
									type="email"
									placeholder="email@example.com"
									{...field}
								/>
							</FormControl>
							<FormDescription>確認メールが送信されます</FormDescription>
							<FormMessage />
						</FormItem>
					)}
				/>

				<FormField
					control={form.control}
					name="currentPassword"
					render={({ field }) => (
						<FormItem>
							<FormLabel>現在のパスワード</FormLabel>
							<FormControl>
								<Input type="password" {...field} />
							</FormControl>
							<FormMessage />
						</FormItem>
					)}
				/>

				<Button type="submit">変更を保存</Button>
			</form>
		</Form>
	);
};
